module.exports = __webpack_public_path__ + "static/media/Ольга Евсеева РУБ 2017 Высоко-высоко-3.png";